/**
 * StatCard.jsx — KPI card using the AE Tracker design system .kpi class.
 *
 * Props:
 *   label      - display label (e.g. "Open Cases")
 *   value      - numeric value to display
 *   icon       - React element for the kpi-icon
 *   colorClass - "brand" | "warn" | "danger" | "info" (tints the kpi-icon and value)
 *   meta       - optional small text below the value
 *   loading    - if true, shows a placeholder
 *   onClick    - optional click handler
 */

import React from 'react';

export default function StatCard({
  label,
  value,
  icon,
  colorClass = 'brand',
  meta,
  loading = false,
  onClick,
}) {
  const isClickable = typeof onClick === 'function';

  return (
    <div
      className={`kpi${colorClass ? ` ${colorClass}` : ''}${isClickable ? ' clickable' : ''}`}
      onClick={isClickable ? onClick : undefined}
      role={isClickable ? 'button' : undefined}
      tabIndex={isClickable ? 0 : undefined}
      onKeyDown={isClickable ? (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(); }
      } : undefined}
    >
      <div className="kpi-label">
        {icon && (
          <span className={`kpi-icon ${colorClass}`}>
            {icon}
          </span>
        )}
        {label}
      </div>
      <div className="kpi-value">
        {loading ? '—' : (value ?? '—')}
      </div>
      {meta && (
        <div className="kpi-meta">{meta}</div>
      )}
    </div>
  );
}
